// eslint-disable-next-line no-unused-vars
import React from 'react';

const Footer = () => (
  <footer
    className="nav-horizontal border nav-chevron nav-footer"
    data-toggle="nav"
    data-responsive="md"
  >
    <div className="container stack-3 pad-2-lr pad-3-t pad-4-b">
      <div className="stack">
        <p className="legal-2">AXP Restricted</p>
        <p className="legal-1">
          This Website is for authorized use only. By using this website, all users acknowledge
          notice of, and agree to comply with, American Express Data Protection and Privacy
          Policies, the American Express Binding Corporate Rules as well as with applicable laws
          and regulations. Safeguarding the personal data of our customers, prospects, third
          parties and colleagues. Compliance with our privacy standards and privacy policies
          protects you, data subjects and our company from the consequences of a data privacy
          breach or other potential privacy and data protection violations. Privacy information
          and related material will be found on <a href="https://www.americanexpress.com/us/privacy-center/">American Express Privacy Center</a>.
        </p>
      </div>
    </div>
  </footer>
);

Footer.displayName = 'Footer';

export default Footer;
